const remote = (process.env.NODE_ENV === 'test' ? require('./remoteMock') : require('./remoteHTTP')).default;

export default remote;